export default {
  init() {
    this.handleOfficeSelector()
    this.handleContactForm()
    this.drawMap();
  },
  drawMap() {
    const maps = $('.google-map');
    $(maps).each(function (a, b) {
      /* eslint-disable */
      var icon =
        'https://developers.google.com/maps/documentation/javascript/examples/full/images/';
      let position = {lat: parseFloat($(b).attr('data-lat')), lng: parseFloat($(b).attr('data-lng'))};
      // eslint-disable-next-line no-undef
      let map = new google.maps.Map(document.getElementById($(b).attr('id')), {
        center: position,
        zoom: 11,
        styles: [
          {
            "featureType": "all",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#3e0063"
              }
            ]
          },
          {
            "featureType": "all",
            "elementType": "labels.text.fill",
            "stylers": [
              // {
              //   "gamma": 0
              // },
              // {
              //   "lightness": 20
              // },
              {
                "color": "#aa6ece"
              }
            ]
          },
          {
            "featureType": "all",
            "elementType": "labels.text.stroke",
            "stylers": [
              // {
              //   "saturation": -31
              // },
              // {
              //   "lightness": -50
              // },
              {
                "color": "#4b0a6e"
              },
              // {
              //   "weight": 0
              // },
              // {
              //   "gamma": 0
              // }
            ]
          },
          {
            "featureType": "all",
            "elementType": "labels.icon",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "landscape",
            "elementType": "geometry",
            "stylers": [
              // {
              //   "color" : "#54187a"
              // },
              // {
              //   "lightness": 30
              // },
              // {
              //   "saturation": 30
              // }
            ]
          },
          {
            "featureType": "poi",
            "elementType": "geometry",
            "stylers": [
              // {
              //   "saturation": 20
              // }
              {
                "color" : "#300050"
              },
            ]
          },
          {
            "featureType": "poi.park",
            "elementType": "geometry",
            "stylers": [
              // {
              //   "lightness": 20
              // },
              // {
              //   "saturation": -20
              // },
              {
                "color" : "#300050"
              },
            ]
          },
          {
            "featureType": "road",
            "elementType": "geometry",
            "stylers": [
              // {
              //   "lightness": 10
              // },
              // {
              //   "saturation": -30
              // }
              {
                "color" : "#54187a"
              },
            ]
          },
          {
            "featureType": "road",
            "elementType": "geometry.stroke",
            "stylers": [
              // {
              //   "saturation": 25
              // },
              // {
              //   "lightness": 25
              // }
              {
                "color" : "#54187a"
              },
            ]
          },
          {
            "featureType": "water",
            "elementType": "all",
            "stylers": [
              // {
              //   "lightness": -20
              // }
              {
                "color" : "#300050"
              },
            ]
          }
        ]
      });
      new google.maps.Marker({position: position, map: map, icon:$(b).attr('data-icon') });
      /* eslint-enable */
    })
  },
  handleOfficeSelector() {
    $('#office-selector').change(function () {
      const val = $(this).val()
      $('.office-details, .office-map').hide();
      $('.office-details[data-office=' + val + ']').show();
      $('.office-map[data-office=' + val + ']').show();
    });
  },
  enableTestProvince(enable) {
    $('#test-province').prop('disabled', !enable)
  },
  enableProvince(enable) {
    $('#province-select').toggle(enable) // visual hide/show
    $('#province-select select').prop('disabled', !enable) // prevents interaction
    $('#province-select select option').first().prop('selected', true)
    $('#test-province').val('');
  },
  enableProvinceCanada(enable) {
    $('#province-select-canada').toggle(enable)
    $('#province-select-canada select').prop('disabled', !enable)
    $('#province-select-canada select option').first().prop('selected', true)
  },
  enableProvinceAustralia(enable) {
    $('#province-select-australia').toggle(enable)
    $('#province-select-australia select').prop('disabled', !enable)
    $('#province-select-australia select option').first().prop('selected', true)
  },
  enableProvinceUkraine(enable) {
    $('#province-select-ukraine').toggle(enable)
    $('#province-select-ukraine select').prop('disabled', !enable)
    $('#province-select-ukraine select option').first().prop('selected', true)
  },
  sendPostSuccessParam(redirectUrl) {
    $.post({
        url: redirectUrl,
        data: { formSuccess: true},
      })
      .done(function(data) {
        const iframe = '<iframe src="' + redirectUrl + '" width=0 height=0 frameborder="0" style="height:0;position:absolute;bottom:-300px;"></iframe>'
        $('body').addClass('thank-you')
        $('#gated-form-wrapper').hide()
        $('body').html(data);
        $('body').append(iframe);
        $(window).scrollTop(0);
      })
  },
  storeUserDetails(serialisedData) {
    window.localStorage.setItem('precisely', JSON.stringify(serialisedData))
    /*$.ajax({
      type: 'POST',
      url: $('body').attr('data-ajax-url'),
      data: {
        data: serialisedData,
        action: 'saveDetails',
      },
    });*/
  },
  prepopulateForm() {
    if (window.localStorage.getItem('precisely')) {
      const data = JSON.parse(window.localStorage.getItem('precisely'))
      const fields = [
        'FirstName',
        'LastName',
        'Job_Title1',
        'Company',
        'CompanyWebsite',
        'EmailAddress',
        'BusPhone',
        'C_Country',
        'C_State_Prov',
      ]
      data.forEach(function (a) {
        if (fields.indexOf(a.name) >= 0) {
          $('form.contact-form input[name="' + a.name + '"], form.contact-form select[name="' + a.name + '"]').val(a.value).change()
        }
        if (a.name == 'confirmedEmailOptIn1' && a.value == 'TRUE') {
          $('form#contact-form input[name="confirmedEmailOptIn1"]').prop('checked', true);
          $('form#contact-form input[name="confirmedEmailOptIn1"]').parents('.form-group').hide()
        }
      })
    }
    // Populate hidden inputs via query strings
    if (window.location.search){
      let query_array_pairs ={};
      let allowed_params = ['utm_campaign', 'utm_content', 'utm_source', 'utm_medium', 'utm_term'];
      const query = window.location.search;

      // Remove ? and split by &
      const query_array = query.substring(1).split('&');
      // Add each utm parameter as key value pair
      for (let i= 0; i <= query_array.length-1; i++){
        const pair = query_array[i].split('=')
        // Check for match
        if (allowed_params.includes(pair[0])) {
          // Sanitize and add
          query_array_pairs[pair[0]] = pair[1].replace(/[^a-zA-Z0-9 _-]/g, '');
        }
      }

      const formInputsToPopulate = document.querySelectorAll('input[type="hidden"]');
      formInputsToPopulate.forEach(input => {
        // Find utm inputs
        if (input.name.startsWith('utm')) {
          if (query_array_pairs.hasOwnProperty(input.name)) {
            // Add query string parameters into hidden input
            input.value = query_array_pairs[input.name];
          }
        }
      });
    }
  },
  toggleMarketingEmail() {


  },
  checkStoredData() {
    let found = 0
    const data = JSON.parse(window.localStorage.getItem('precisely'))
    const fields = [
      'FirstName',
      'LastName',
      'Job_Title1',
      'Company',
      'EmailAddress',
      'BusPhone',
    ]

    if (data && data.length) {
      data.forEach(function (a) {
        if (fields.indexOf(a.name) >= 0 && a.value != '') {
          found++
        }
      })
      return (found == fields.length) ? true : false
    } else {
      return false
    }
  },
  handleContactForm() {
    let that = this;
    $('form.contact-form #country-select').change(function () {

      $('#marketingEmailOptIn').hide();
      if ($(this).children(':selected').attr('id') != 'country-usa' && $(this).children(':selected').attr('id') != 'country-uk') {
        $('#marketingEmailOptIn').show()
      }
      $('#province-select').hide()
      that.enableTestProvince($(this).children(':selected').attr('id') != 'country-usa' && $(this).children(':selected').attr('id') != 'country-canada'  && $(this).children(':selected').attr('id') != 'country-australia' )
      that.enableProvince($(this).children(':selected').attr('id') == 'country-usa' )
      that.enableProvinceCanada($(this).children(':selected').attr('id') == 'country-canada' )
      that.enableProvinceAustralia($(this).children(':selected').attr('id') == 'country-australia' )
      that.enableProvinceUkraine($(this).children(':selected').attr('id') == 'country-ukraine' )
    });
    setTimeout(function () {
      that.prepopulateForm();
    })

    $('form.contact-form #interested-in').change(function () {
      const val = $(this).val();
      val === 'Sales' ? $('#inquiring-about').prop('required', true).parent().show() : $('#inquiring-about').prop('required', false).parent().hide();

      $('.support-message').hide();
      $('.hidable').show();

      if(val == 'Support') {
        $('.support-message').show();
        $('.hidable').hide();
      }
    });

    $('form.contact-form [name="FirstName"]').change(function () {
      if ($(this).val() !== '' && $('#pre-id-a').val() === '') {
        $('#pre-id-b').val(window.precisely.bt_value);
      } else {
        $('#pre-id-b').val('');
      }
    });

    if ($('form.contact-form .multiple-select-item').length) {
      $('form.contact-form .multiple-select-item').last().get(0).setCustomValidity('Please select item(s) in the list.');
    }

    $('form.contact-form .multiple-select-item').change(function () {
      const values = [];
      const validationInput = $('form.contact-form .multiple-select-item').last();

      $('form.contact-form .multiple-select-item:checked').each(function () {
        values.push($(this).val());
      });

      validationInput.attr('required', !values.length > 0);
      validationInput.get(0).setCustomValidity(!values.length > 0 ? 'Please select item(s) in the list.' : '');
      $('form.contact-form [name="Multiple_Select_Field"]').val(values.join(', '));
    });

    $('form.contact-form').submit(function (e) {
      e.preventDefault();
      const form = $(this);
      $(form).find('.submit-button-js').attr('disabled', 'disabled');

      // honeypot
      if (form.find('.trap').val() != undefined && form.find('.trap').val() != '') {
        console.log('honeypot if')
        return false
      }

      // reCaptcha
      /* global grecaptcha */
       grecaptcha.ready(function () {
        grecaptcha.execute(window.precisely.google_recaptcha_site_key, { action: 'submit' }).then(function (token) {
          const recaptchaResponse = document.getElementById('recaptcha-response');
            recaptchaResponse.value = token;

          $(form).css('opacity', '0.5')
          $(form).find('.loader').addClass('d-block')

           // Marketo compatibility
          $(form).find('#clone_title1').val($('input[name=Job_Title1]').val());
          $(form).find('#clone_email').val($('input[name=EmailAddress]').val());
          $(form).find('#clone_phone').val($('input[name=BusPhone]').val());
          $(form).find('#clone_country').val($('#country-select').val());
          $(form).find('#clone_state').val($('#province-select select').val());
          $(form).find('#clone_optin').val($('input[name=confirmedEmailOptIn1]').val());

          const myData = $(form).serialize();
          const myDataArr = $(form).serializeArray();
          that.storeUserDetails(myDataArr);

          $.ajax({
            type: 'POST',
            url: $(form).attr('action'),
            data: myData,
            success: function (data) {
              $(form).css('opacity', '1')
              $(form).find('.loader').removeClass('d-block')
              $('.form-message').hide();
              if (data.match('DefaultFormSubmitConfirmation')) {
                if ($(form).attr('data-redirect')) {
                  location.href = $(form).attr('data-redirect');
                } else {
                  that.sendPostSuccessParam(location.href + '?stage=2')
                }
              } else {
                if (data.match('FormEmailError')) {
                  $('.form-email').show();
                } else {
                  $('.form-ko').show();
                }

                $(form).find('.submit-button-js').attr('disabled', '');
                $(form).find('.submit-button-js').prop('disabled', false);
              }
            },
          });

       });
     });
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/contact.js